const ProfileLoading = ({ editProfile = false }) => {
    return (
        <main className='py-2 px-40 max-lg:px-3 text-start space-y-4'>
            <section className="border p-3 rounded-xl">
                <section className={`flex items-center max-lg:flex-col gap-8 ${editProfile ? 'justify-center' : 'justify-between'}`}>
                    <div className="flex items-center gap-2">
                        <div className='size-32 l-load-dt rounded-full'></div>
                        {!editProfile &&
                            <div className="space-y-2">
                                <div className="l-load-dt h-4 rounded-md w-52"></div>
                                <div className="l-load-dt h-3 rounded-md w-44"></div>
                            </div>}
                    </div>
                    {!editProfile &&
                        <div className="flex gap-2 items-center">
                            
                        </div>
                    }
                </section>

                <section>
                    <div className='my-4'>
                        <div className="grid grid-cols-3 gap-3 max-lg:grid-cols-1">
                            {[...Array(7)].map((_, i) => (
                                <div key={i} className="h-16 l-load rounded"></div>
                            ))}
                        </div>
                        {editProfile && <div className="flex justify-end w-full mt-4">
                            <div className="w-32 h-10 l-load-dt rounded"></div>
                        </div>}
                    </div>
                </section>
            </section>
        </main>
    );
};
export default ProfileLoading;
